/**
 * Trigger a browser download from a Blob and optional filename from Content-Disposition.
 */
export function parseFilenameFromContentDisposition(
  contentDisposition: string | null,
  fallback: string,
): string {
  if (!contentDisposition) return fallback;
  const match = contentDisposition.match(
    /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
  );
  if (match?.[1]) {
    return match[1].replace(/['"]/g, "");
  }
  return fallback;
}

export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

export async function downloadFromResponse(
  response: Response,
  fallbackFilename: string,
  autoDownload = true,
): Promise<Blob> {
  const blob = await response.blob();
  if (autoDownload) {
    const filename = parseFilenameFromContentDisposition(
      response.headers.get("Content-Disposition"),
      fallbackFilename,
    );
    downloadBlob(blob, filename);
  }
  return blob;
}
